<template>
  <TextInput
    v-if="currentTournament.entry_fee.required"
    v-model.number="tournamentAmmount"
    class="hide-arrows-wrapper w-auto"
    type="number"
    :label="$t('_web_tournaments_cost', 'Cost')"
    :placeholder="
      $t('_web_tournament_cost-placeholder', 'Enter tournament cost')
    "
    :data-vv-as="$$t('Qty of substitutes:', 'substitutes-count-label')"
  />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import TextInput from '@/components/atoms/form/HeraFormTextInput';
import { translate } from '@/mixins/translate';
export default {
  name: 'TournamentAmmountSetting',

  components: {
    TextInput,
  },
  mixins: [translate('_web_tournament_settings')],
  computed: {
    ...mapGetters(['currentTournament', 'isTournamentFieldDisabled']),
    paidTournament() {
      return this.currentTournament.entry_fee.required;
    },
    tournamentAmmount: {
      get() {
        return this.$lodash.get(this.currentTournament, 'entry_fee.cost', 0);
      },
      set(newVal) {
        const numericValue = parseFloat(newVal);
        this.updateCurrentTournament({
          cost: numericValue,
          component: 'entry_fee',
        });
      },
    },
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
  },
};
</script>
